import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import {
  selectUIStates,
  selectUser,
  setSidebarSnippet,
  setUIStates,
} from "../../redux/features/appData/appDataSlice";
import "./SnippetSwitcher.css";
import "../../css/Icons.css";
import { Snippet } from "winslow-core";
import { iconPath } from "winslow-core";

type SnippetSwitcherProps = {
  snippets: Snippet[];
  selectedSnippetId: string;
};

export default function SnippetSwitcher({
  snippets,
  selectedSnippetId,
}: SnippetSwitcherProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  const storeUser = useSelector(selectUser);
  const uiStates = useSelector(selectUIStates);

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // no floaters on avatar menu pages
    dispatch(
      setUIStates({
        ...uiStates,
      })
    );

    const index = snippets.findIndex((snippet: Snippet) => {
      return snippet.id === selection;
    });

    if (index !== -1) {
      dispatch(setSidebarSnippet({ ...snippets[index] }));
    }
  };

  return (
    <>
      <div className="snippet-image-and-name" onClick={handleButtonClick}>
        <div className="snippet-caret">
          <img src={iconPath("accordion_open.svg", storeUser)} alt="" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}>
        {snippets.map((snippet: Snippet) => {
          return (
            <MenuItem
              key={"snippet-" + snippet.id}
              onClick={() => handleMenuSelection(snippet.id)}>
              {snippet.name}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
